import { Help } from 'views/dashboard/help';
import { OnboardingView } from 'views/onboarding/onboarding';
import { Primitives } from 'views/dev/primitives';
import {_t} from "../app/translations";

const Routes = [
  {
    path: '/app/onboarding',
    view: OnboardingView,
    layout: 'onboarding',
    permission: 'user',
    title: _t('welcome'),
    allowNotOnboarded: true
  },
  {
    path: '/app/help',
    view: Help,
    layout: 'app',
    permission: 'user',
    title: _t('help.label')
  },

  // Development-only: the primitive smoke view used to diff the UI refresh
  // against ../ui-reference. Not registered in production builds.
  ...(process.env.NODE_ENV === 'development' ? [{
    path: '/app/dev/primitives',
    view: Primitives,
    layout: 'app',
    permission: 'user',
    title: 'Primitives'
  }] : [])
]

export default Routes;
